import type { BadgeVariant, MenuItem } from '@/data/menu';
import menu from '@/data/menu';
import { defineStore } from 'pinia';

interface MenuState {
    menu: MenuItem[];
}

function findMenu(menu: MenuItem[], badge: string): MenuItem | undefined {
    const item = menu.find((item: MenuItem) => item.name === badge);

    if (item) {
        return item;
    }

    return menu.flatMap((item: MenuItem) => item.sub ?? []).find((item: MenuItem) => item.name === badge);
}

function findParentMenu(menu: MenuItem[], targetName: string): MenuItem | undefined {
    return menu.find((item: MenuItem) => item.sub?.some((subItem: MenuItem) => subItem.name === targetName));
}

export const useMenuStore = defineStore('menu', {
    state: (): MenuState => {
        return { menu: menu.main ?? [] };
    },
    actions: {
        addBadge(badge: string, count: number, variant: BadgeVariant = 'primary') {
            const menu = findMenu(this.menu, badge);

            if (!menu) {
                return;
            }

            menu.badge = count.toString();
            menu['badge-variant'] = variant;

            // Find and open parent menu if this is a sub-item
            const parent = findParentMenu(this.menu, badge);
            if (parent) {
                parent.open = true;
            }
        },
        removeBadge(badge: string) {
            const menu = findMenu(this.menu, badge);

            if (!menu) {
                return;
            }

            delete menu.badge;
            delete menu['badge-variant'];
        },
    },
});
